import report from '../../../component/common/report';
import PageBase from '../../../common/pageBase';


class cardLoan extends PageBase {
  constructor() {
    super()
    this.init();
  }
  init(){
    require('../../../component/classBase');
    require('../../../common/base.css');
    require('./widget/widget.less')
    require('./css.less');
    let tpl = require('./index.tpl.html');
    // 这个显示的轮播图知识默认的 如果有接口返回的话使用接口返回的图片
    var imgs = [
      {
        'adImgUrl':"https://loan-public-test-1251016329.cos.ap-guangzhou.myqcloud.com/yztloan/ad/jC5hq4mvRghr384FTAhvVczgKMTrWPVQZu1FHLfZ3jI.png",
        'redirectUrl':''
      },
      {
        'adImgUrl':"https://loan-public-test-1251016329.cos.ap-guangzhou.myqcloud.com/yztloan/ad/1BiIpQnfL4VwKMQ0tHUYxIoYgg5VEI8eMgmQlJyY8eI.jpg",
        'redirectUrl':'https://cardloan.xiaoying.com/fe/website/landPage/walk_for_love.html'
      }
    ];
    tpl = $(tpl);
    $('#container').html(tpl);
    let header = require('./widget/header.tpl.html');
    $('.header').html(header);
    let footer = require('./widget/footer.tpl.html');
    $('.footer-place').html(footer);
    this.confSend("https://cardloan.xiaoying.com/h5/common/get_adv_info", {key: 'cardloan_web_banner'},true).then((json) => {
      if(json.errcode === 0 && json.data.cardloan_web_banner.adList.length>1){
        this.generateDom(json.data.cardloan_web_banner.adList);
      } else if(json.errcode === 0 && json.data.cardloan_web_banner.adList.length === 1){
        this.initDom(json.data.cardloan_web_banner.adList[0]);
      }else {
        this.generateDom(imgs);
      }
    }).catch((err) => {
        this.generateDom(imgs);
    });

    $('.a1').siblings().removeClass('nav-on');
    $('.a1').addClass('nav-on');
    $('.a1').click(() => {
      $('.a1').attr("href", "#");
    })
    report.init({softid: 5});
  }
  generateDom(imgs){
    imgs.forEach((item)=>{
      this.initDom(item);

    });
    this.initSwiper();

  }
  initDom(item){
    let div = $('<div></div>');
    div.css('background-image',`url(${item.adImgUrl})`);
    div.addClass('swiper-slide banner');
    if(item.redirectUrl){
      div.click(()=>{
        location.href = item.redirectUrl;
      });
    }
    div.appendTo($('.swiper-wrapper'));
  }
  initSwiper(){
    var mySwiper = new Swiper('.swiper-container', {
      autoplay: {
        delay: 3000,
      },
      loop: true,
      pagination: {
        el: '.swiper-pagination',
      },
    });
    $('.swiper-pagination').on('click', "span", function () {
      let index = $(".swiper-pagination span").index($(this));
      mySwiper.slideTo(index + 1);
    });
  }

}
new cardLoan();





// WEBPACK FOOTER //
// ./src/module/landPage/index/index.js